import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from '../toast';
import { CookieService } from './services';

@NgModule({
    imports: [
        CommonModule,

        ToastModule,
    ],
    providers: [
        CookieService,
        {
            provide: 'DOCUMENT',
            useValue: document,
        },
    ],
})

export class CookieModule {
}
